import { ReportStatus } from 'src/api';
import { ReportType } from 'src/graphql';
import * as Types from 'src/types';

export const getMessagingDisabled = (report: ReportType) => {
  const {
    anonymous,
    Reporter,
    submissionMode,
    PhoneLineType,
    reporterExists,
    status,
  } = report;

  const isVaultTalkReport = submissionMode === Types.SUBMISSION_MODE.VAULT_TALK;
  const isNonMobileVaultTalk =
    isVaultTalkReport && PhoneLineType !== Types.PhoneLineType.MOBILE;
  const isMIReport = submissionMode === Types.SUBMISSION_MODE.MCC;
  const isUnknownMIReport =
    isMIReport &&
    !anonymous &&
    !Reporter?.name &&
    !Reporter?.email &&
    !reporterExists;

  const isUnknownImportedReport =
    submissionMode === Types.SUBMISSION_MODE.BULK_IMPORT &&
    !Reporter?.email &&
    !reporterExists;

  const isClosedImportedReport =
    submissionMode === Types.SUBMISSION_MODE.BULK_IMPORT &&
    status === ReportStatus.CLOSED;

  const messagingDisabled =
    isNonMobileVaultTalk ||
    isUnknownMIReport ||
    isUnknownImportedReport ||
    isClosedImportedReport;

  return messagingDisabled;
};
